<template>
  <div class="project-card">
    <router-link :to="`/projects/${project.slug}`">
      <div class="project-image-container">
        <img v-if="project.featuredImage" :src="project.featuredImage" :alt="project.title" class="project-image">
        <div v-else class="placeholder-image">Image placeholder</div>
      </div>
      <div class="project-content">
        <h2>{{ project.title }}</h2>
        <p class="project-date">{{ project.date }}</p>
        <p class="project-description">{{ project.summary }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    project: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.project-card {
  background: #535352;
  border-radius: 8px;
  margin-bottom: 30px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.project-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.project-card a {
  display: flex;
  text-decoration: none;
  color: white;
}

.project-image-container {
  flex: 0 0 40%;
  background: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-image {
  color: #aaa;
  font-style: italic;
  padding: 80px 0;
  text-align: center;
  width: 100%;
}

.project-content {
  flex: 0 0 60%;
  padding: 20px;
  text-align: left;
}

.project-content h2 {
  margin-top: 0;
  color: #FCBA03;
}

.project-date {
  font-style: italic;
  margin-bottom: 15px;
  font-size: 0.9em;
}

.project-description {
  line-height: 1.6;
}

@media (max-width: 768px) {
  .project-card a {
    flex-direction: column;
  }

  .project-image-container, 
  .project-content {
    flex: 0 0 100%;
  }
}
</style>